import React from 'react'

const DevOps_Tools = () => {
  return (
    <div>
        {/* collapseFourtySix */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingFourtySix">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFourtySix" aria-expanded="false" aria-controls="collapseFourtySix">
                    DevOps Tools
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseFourtySix" className="accordion-collapse collapse" aria-labelledby="headingFourtySix" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Git:</strong>
                    <ul>
                        <li>Version Control</li>
                        <li>Git Introduction</li>
                        <li>Git Installation</li>
                        <li>Create and Clone Repository</li>
                        <li>Commonly used commands in Git</li>
                        <li>Working with Remote Repository</li>
                        <li>Branching and merging in Git</li>
                        <li>Merge Conflicts</li>
                        <li>Stashing, Rebasing, Reverting and Resetting</li>
                        <li>Git Workflows</li>
                    </ul>

                    <strong>Kubernetes</strong>
                    <ul>
                        <li>Introduction to Container Orchestration</li>
                        <li>Kubernetes Core Concepts</li>
                        <li>Understanding Pods</li>
                        <li>ReplicaSet</li>
                        <li>Replication Controller</li>
                        <li>Deployments</li>
                        <li>DaemonSets</li>
                        <li>Networking in Kubernetes</li>
                        <li>Rolling Updates</li>
                        <li>Rollbacks</li>
                        <li>Scaling Application</li>
                        <li>Services</li>
                        <li>Persistent Storage in Kubernetes</li>
                        <li>Primitives for PersistentVolumeClaims</li>
                        <li>Secrets and ConfigMaps</li>
                        <li>Headless Services</li>
                        <li>StatefulSets</li>
                        <li>Helm Charts & its Deploying</li>
                        <li>MicroServices Architecture</li>
                    </ul>

                    <strong>Docker</strong>
                    <ul>
                        <li>Containerization</li>
                        <li>Namespaces</li>
                        <li>Docker</li>
                        <li>Docker Architecture</li>
                        <li>Container Lifecycle</li>
                        <li>Docker CLI</li>
                        <li>Port Binding</li>
                        <li>Docker Networking</li>
                        <li>Detached and Foreground Mode</li>
                        <li>Dockerfile</li>
                        <li>Dockerfile Instructions</li>
                        <li>Docker Image</li>
                        <li>Docker Registry</li>
                        <li>Container Storage</li>
                        <li>Volumes</li>
                        <li>Docker Compose</li>
                        <li>Docker Swarm</li>
                    </ul>

                    <strong>Jenkins</strong>
                    <ul>
                        <li>Introduction to Continuous Integration</li>
                        <li>Jenkins Architecture</li>
                        <li>Plugin Management in Jenkins</li>
                        <li>Jenkins Security Management</li>
                        <li>Notification in Jenkins</li>
                        <li>Jenkins Master-Slave Architecture</li>
                        <li>Jenkins Delivery Pipeline</li>
                        <li>Jenkins Declarative Pipeline</li>
                        <li>CI/CD Pipeline</li>
                        <li>Integrate Git with Jenkins</li>
                        <li>Integrate Maven with Jenkins</li>
                    </ul>

                    <strong>Terraform</strong>
                    <ul>
                        <li>Introduction to Terraform</li>
                        <li>Terraform vs Ansible</li>
                        <li>Terraform Architecture</li>
                        <li>YAML and JSON</li>
                        <li>Terraform CLI</li>
                        <li>Terraform Providers</li>
                        <li>Terraform Modules</li>
                        <li>Terraform Variables, Outputs, Key Concepts</li>
                        <li>Terraform Loops</li>
                        <li>Terraform Functions and Provisioners</li>
                        <li>Terraform Configuration & its File</li>
                        <li>Terraform Common Commands</li>
                        <li>Managing Terraform Resources</li>
                        <li>Terraform State & its Commands</li>
                        <li>State Management</li>
                        <li>Terraform Project</li>
                    </ul>

                    <strong>Ansible</strong>
                    <ul>
                        <li>Introduction to Configuration Management</li>
                        <li>Infrastructure as Code</li>
                        <li>Introduction to Ansible</li>
                        <li>Ansible Architecture</li>
                        <li>Inventory Management</li>
                        <li>Ansible Modules</li>
                        <li>AD-HOC Commands</li>
                        <li>Ansible Playbooks</li>
                        <li>Ansible Roles</li>
                    </ul>

                    <strong>Jira</strong>
                    <ul>
                        <li>Introduction to JIRA</li>
                        <li>Installing</li>
                        <li>Create project, Scheme, Issues</li>
                        <li>Add Users</li>
                        <li>Jira Dashboard and Gadgets</li>
                        <li>Kanban Boards and Scrum</li>
                        <li>Write Test Cases, Test Cycles</li>
                        <li>Defect / Bug Templates</li>
                        <li>Logging defects</li>
                        <li>Defect Lifecycle</li>
                        <li>Searching Defects and doing bulk Changes</li>
                        <li>Search Filters</li>
                        <li>Advanced Search using JQL</li>
                        <li>Jira Query Language</li>
                        <li>Generating Reports</li>
                        <li>Types of Reports</li>
                        <li>Backlog</li>
                        <li>Agile Project Monitoring and reporting with Jira</li>
                    </ul>

                    <strong>Prometheus and Grafana</strong>
                    <ul>
                        <li>Introduction to Prometheus and Grafana</li>
                        <li>Prometheus and Grafana Setup</li>
                        <li>Monitoring using Prometheus</li>
                        <li>Dashboard</li>
                        <li>Visualization using Grafana</li>
                        <li>Creating a Dashboard to monitor the Pipeline</li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
  )
}

export default DevOps_Tools